export const customCodeUiSchema = {
  type: "Group",
  label: "Custom code"
};
